import { parsePhoneNumberWithError } from 'libphonenumber-js';

export const formatPhoneNumberToInternational = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return '';
  }

  try {
    const parsedPhoneNumber = parsePhoneNumberWithError(phoneNumber);
    return parsedPhoneNumber.formatInternational();
  } catch (_error) {
    console.error('Error parsing phone number.');
    return phoneNumber; // Return the original number if parsing fails
  }
};
